import messages_en from '../translations/en.json';
import messages_sp from '../translations/sp.json';
import messages_br from '../translations/br.json';
import messages_fr from '../translations/fr.json';
import { TENANT_TEXT_MAPPING } from 'constants/tenant-config';
import domainManagementService from 'services/domainManagementService';

export const languages = {
  English: 'en',
  Spanish: 'sp',
  Brazilian: 'br',
  French: 'fr',
};

const translations = {
  en: messages_en,
  sp: messages_sp,
  br: messages_br,
  fr: messages_fr,
};

let currentLang = localStorage.getItem('language') || 'en';

export const setLang = (lang) => {
  if (translations[lang]) {
    currentLang = lang;
    localStorage.setItem('language', lang);
  }
};

export const getLang = () => currentLang;

export const tDefault = (key, values = {}) => {
  const dict = translations[currentLang] || {};
  let text = dict[key] || '';

  if (!text) {
    return text;
  }

  if (
    values === null ||
    typeof values !== 'object' ||
    Object.keys(values).length === 0
  ) {
    return text;
  }

  Object.keys(values).forEach((k) => {
    text = text.replace(new RegExp(`{${k}}`, 'gi'), values[k]);
  });

  return text;
};

export const replaceBrandText = (text) => {
  if (!text) return text;

  // Detect tenant key from domain
  const tenantKey = domainManagementService.getDomainConfig().domainKey;

  const tenantMapping = TENANT_TEXT_MAPPING[tenantKey];
  if (!tenantMapping) return text;

  let result = text;

  // 1. Replace "Turn It Blue Digital LLC" first (most specific)
  result = result.replace(
    /Turn It Blue Digital LLC/gi,
    tenantMapping.TENANT_NAME_LLC
  );

  // 2. Replace "Turn It Blue Digital"
  result = result.replace(
    /Turn It Blue Digital/gi,
    tenantMapping.TENANT_NAME_DIGITAL
  );

  // 3. Replace "Turn It Blue Ads"
  result = result.replace(/Turn It Blue Ads/gi, tenantMapping.TENANT_NAME_ADS);

  // 4. Replace "turnitbluedigital"
  result = result.replace(/turnitbluedigital/gi, tenantMapping.TENANT_DOMAIN);

  // 5. Replace the signoff "Kate"
  result = result.replace(/Kate/gi, tenantMapping.TENANT_SIGNOFF);

  // 6. Replace the "TIB Ads"
  result = result.replace(/TIB Ads/gi, tenantMapping.TENANT_SHORT_NAME);
  result = result.replace(/TIB/gi, tenantMapping.TENANT_SHORT_NAME);
  
  // 7. Replace "Turn It Blue" (most general)
  result = result.replace(/Turn It Blue/gi, tenantMapping.TENANT_NAME);
  
  return result;
};

export const t = (key, values = {}) => {
  // Get text from translation
  let text = tDefault(key, values);

  // Apply brand replacement
  text = replaceBrandText(text);

  return text;
};

export const tWithIntl = (intl, key, values = {}) => {
  // Use intl.formatMessage to replace placeholders
  let text = intl.formatMessage({ id: key }, values);

  // Apply brand replacement
  text = replaceBrandText(text);

  return text;
};

export default {
  languages,
  setLang,
  getLang,
  t,
};
